import { createRoot } from "react-dom/client";

export const root = createRoot(document.getElementById("root")!);
